export const ThreatsVulnerabilitiesMitigationsQuestions = [
  {
    id: 'threats-001',
    text: 'Which security mechanism is designed to deliberately attract attackers to a decoy system while monitoring their activities?',
    options: [
      'DNS Sinkhole',
      'Honeypot',
      'Waterhole Attack',
      'DNS Blackhole'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.3,
    explanation: 'A honeypot is specifically designed to attract and monitor attackers, providing insights into attack methods. DNS sinkholes redirect malicious traffic, waterhole attacks are actually an attack method, and DNS blackholes block malicious domains.'
  },
  {
    id: 'threats-002',
    text: 'Users report that the company website sometimes redirects to a different site, but only for some users and not consistently. What type of attack is most likely?',
    options: [
      'Cross-site scripting',
      'SQL injection',
      'DNS cache poisoning',
      'DDoS attack'
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'DNS cache poisoning can cause inconsistent redirects because only some DNS servers may be poisoned. DDoS would affect all users, XSS typically requires user interaction, and SQL injection affects database operations.'
  },
  {
    id: 'threats-003',
    text: 'An analyst finds encapsulated IPv6 traffic in a network where IPv6 is not used. What technique was likely used for data exfiltration?',
    options: [
      'ARP poisoning',
      'DNS spoofing',
      'Protocol tunneling',
      'Port scanning'
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.9,
    explanation: 'Protocol tunneling, specifically IPv6 tunneling in this case, is used to hide data within seemingly legitimate traffic. The other techniques don\'t involve encapsulating traffic in different protocols.'
  },
  {
    id: 'threats-004',
    text: 'What\'s the main difference between a worm and a virus?',
    options: [
      'Worms are always visible while viruses are hidden',
      'Worms self-propagate without user interaction while viruses require a host program',
      'Worms only work on Windows while viruses work on all systems',
      'Worms only affect networks while viruses affect files'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.3,
    explanation: 'Worms can spread independently across networks without requiring user interaction or host programs, while viruses need to attach themselves to other programs or files to spread.'
  },
  {
    id: 'threats-005',
    text: 'A security team discovers traffic leaving the network to multiple new domains at regular intervals, but only a few bytes at a time. Which attack is most likely occurring?',
    options: [
      'Port scanning',
      'SYN flood',
      'Ping sweep',
      'DNS tunneling'
    ],
    correctAnswer: 3,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.9,
    explanation: 'DNS tunneling involves sending small amounts of data through DNS queries to multiple domains. The other attacks either generate different traffic patterns or don\'t typically exfiltrate data.'
  },
  {
    id: 'threats-006',
    text: 'Which technique involves hiding code or text within an image file?',
    options: [
      'Hashing',
      'Steganography',
      'Encryption',
      'Tokenization'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'Steganography is the practice of concealing information within other non-secret data, such as hiding code within an image file.'
  },
  {
    id: 'threats-007',
    text: 'If an admin finds that files on a database server were encrypted and last accessed by a domain user, what type of attack does this situation best indicate?',
    options: [
      'Ransomware attack',
      'Insider threat',
      'Brute force attack',
      'SQL injection'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'The combination of file encryption by a legitimate domain user account suggests an insider threat, as this indicates malicious activity from an authorized user.'
  },
  {
    id: 'threats-008',
    text: 'After a penetration test, a report indicates a web application form field is susceptible to XSS. What should the security analyst advise the developers to use to prevent this vulnerability?',
    options: [
      'Strong encryption',
      'Access controls',
      'Input validation',
      'Network segmentation'
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'Input validation is the primary defense against Cross-Site Scripting (XSS) attacks by ensuring that user input is properly sanitized before being processed.'
  },
  {
    id: 'threats-009',
    text: 'Which resource provides the most comprehensive, community-maintained knowledge base of adversary tactics and techniques?',
    options: [
      'MITRE ATT&CK Framework',
      'OWASP Top 10',
      'CVE Database',
      'NIST Special Publications'
    ],
    correctAnswer: 0,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.5,
    explanation: 'The MITRE ATT&CK Framework provides detailed, real-world knowledge of adversary behavior, tactics, and techniques, making it the most comprehensive reference for understanding and defending against actual threat actor behaviors.'
  },
  {
    id: 'threats-010',
    text: "Which protocol offers robust protection for data transmitted across a network?",
    options: [
      "HTTP",
      "SSL",
      "Telnet",
      "TLS"
    ],
    correctAnswer: 3,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.2,
    explanation: "TLS (Transport Layer Security) is the current standard for secure data transmission, providing encryption and authentication. SSL is an older, deprecated protocol. HTTP is unencrypted. Telnet is also unencrypted and highly insecure."
  },
  {
    id: 'threats-011',
    text: "A company needs a cost-effective method to secure its main domain and all associated subdomains. What type of digital certificate should they implement?",
    options: [
      "Single-domain certificate",
      "EV certificate",
      "Wildcard certificate",
      "SAN certificate"
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.7,
    explanation: "A wildcard certificate secures a domain and all its subdomains with a single certificate, simplifying management and reducing costs. Single-domain certificates only secure one specific domain. EV certificates provide higher assurance but don't inherently cover subdomains. SAN certificates can secure multiple domains and subdomains, but require separate entries for each, making wildcards more cost-effective for numerous subdomains."
  },
  {
    id: 'threats-012',
    text: "How can an organization best enforce data protection policies on sensitive data, such as Personally Identifiable Information (PII), based on existing data labeling and classification?",
    options: [
      "DLP solutions",
      "Enforcing strong password policies",
      "Conducting regular vulnerability assessments",
      "Deploying intrusion detection systems"
    ],
    correctAnswer: 0,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.7,
    explanation: "DLP solutions can use data labeling and classification to identify and prevent sensitive data from leaving the organization's control. Strong passwords protect access but don't prevent data exfiltration. Vulnerability assessments find security weaknesses, not enforce data protection policies. Intrusion detection systems monitor for malicious activity but don't prevent data loss based on classification."
  },
  {
    id: 'threats-013',
    text: "What is the primary function of a Web Application Firewall (WAF)?",
    options: [
      "Protecting against network-level attacks like DDoS.",
      "Preventing unauthorized access to the underlying operating system.",
      "Shielding web applications from common attacks like SQL injection and cross-site scripting.",
      "Encrypting data in transit between the client and the server."
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.1,
    explanation: "WAFs are designed to protect web applications from application-layer attacks. DDoS protection is typically handled by separate solutions. Operating system security is addressed through hardening and patching. Encryption is provided by protocols like TLS/SSL."
  },
  {
    id: 'threats-014',
    text: "Geolocation information embedded within a digital image is an example of what type of data?",
    options: [
      "PII",
      "Sensitive data requiring strict access control",
      "Metadata",
      "Encrypted data"
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.5,
    explanation: "Geolocation data is metadata, providing information *about* the image. While it *could* indirectly reveal PII if combined with other data, it's not PII itself. It may be considered sensitive depending on the context, but the most accurate classification is metadata. It is not encrypted by default."
  },
  {
    id: 'threats-015',
    text: "What are potential security risks associated with using public code repositories?",
    options: [
      "Exposure of sensitive information like API keys or credentials.",
      "Increased performance overhead due to code versioning.",
      "Incompatibility with certain development environments.",
      "Limited collaboration features for team projects."
    ],
    correctAnswer: 0,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.9,
    explanation: "A major risk is accidentally committing sensitive data to the repository, making it publicly accessible. Code versioning generally improves, not hinders, performance. Compatibility issues are usually related to specific tools, not repositories themselves. Public repositories are designed to facilitate collaboration."
  },
  {
    id: 'threats-016',
    text: "Which type of firewall is specifically designed to inspect and filter HTTP/HTTPS traffic, protecting web applications from common attacks?",
    options: [
      "Packet Filtering Firewall",
      "Stateful Inspection Firewall",
      "Next-Generation Firewall (NGFW)",
      "Web Application Firewall (WAF)"
    ],
    correctAnswer: 3,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.3,
    explanation: "A WAF focuses on application-layer (Layer 7) traffic, specifically HTTP/HTTPS, to defend against web application attacks like SQL injection and cross-site scripting. Packet filtering firewalls work at the network layer (Layer 3/4). Stateful inspection adds context to packet filtering. NGFWs include WAF functionality but are a broader category."
  },
  {
    id: 'threats-017',
    text: "What protocol is commonly used to securely transmit streaming media, such as encrypted video conferencing?",
    options: [
      "RTP",
      "TCP",
      "UDP",
      "SRTP"
    ],
    correctAnswer: 3,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.8,
    explanation: "SRTP (Secure Real-time Transport Protocol) provides encryption, authentication, and integrity for real-time media streams. RTP is the base protocol for media streaming but lacks security features. TCP is a reliable transport protocol but not ideal for real-time media due to overhead. UDP is a connectionless protocol suitable for streaming but doesn't provide security on its own."
  },
  {
    id: 'threats-018',
    text: "What security measure can significantly reduce the impact of a data breach on a login database?",
    options: [
      "Data encryption at rest",
      "Password hashing",
      "Multi-factor authentication",
      "Regular security audits"
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.5,
    explanation: "Hashing transforms passwords into irreversible strings, protecting them even if the database is compromised. Encryption protects data at rest but doesn't prevent password theft if the database is accessed. MFA adds an extra authentication layer. Audits detect vulnerabilities but don't directly protect passwords in a breach."
  },
  {
    id: 'threats-019',
    text: "What is the key difference between a brute-force attack and a password spraying attack?",
    options: [
      "Brute-force uses social engineering, while password spraying exploits software vulnerabilities.",
      "Brute-force tries many passwords against one account, while password spraying tries a few passwords against many accounts.",
      "Brute-force uses dictionary attacks, while password spraying uses rainbow tables.",
      "Brute-force targets network infrastructure, while password spraying targets web applications."
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.0,
    explanation: "Brute-force focuses on a single account with numerous password attempts. Password spraying uses a small set of common passwords across many accounts. The other options misrepresent the attack methods."
  },
  {
    id: 'threats-020',
    text: "To mitigate application-layer attacks such as SQL injection and cross-site scripting targeting web applications, which security control is most appropriate?",
    options: [
      "A Network Intrusion Prevention System (NIPS)",
      "A Web Application Firewall (WAF)",
      "A Stateful Packet Inspection Firewall",
      "A Host-based Intrusion Detection System (HIDS)"
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.8,
    explanation: "A WAF is specifically designed to inspect HTTP/HTTPS traffic and protect against web application vulnerabilities. A NIPS operates at the network layer. A stateful firewall tracks network connections. A HIDS monitors activity on individual hosts."
  },
  {
    id: 'threats-021',
    text: "When transmitting sensitive video conferencing data over a public network, which protocol provides end-to-end encryption and authentication to ensure confidentiality and integrity?",
    options: [
      "Real-time Transport Protocol (RTP)",
      "User Datagram Protocol (UDP)",
      "Transmission Control Protocol (TCP)",
      "Secure Real-time Transport Protocol (SRTP)"
    ],
    correctAnswer: 3,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.7,
    explanation: "SRTP adds security features like encryption and authentication to RTP, making it suitable for secure video conferencing. RTP lacks built-in security. UDP is a transport protocol without security. TCP is also a transport protocol with reliability features but does not provide encryption for media streams."
  },
  {
    id: 'sec-ops-022',
    text: "A security analyst discovers unusual network traffic originating from an internal workstation to a known malicious IP address. The workstation's operating system logs show no signs of malware installation. However, network logs indicate the workstation is making DNS queries for unusual domains. What is the MOST likely cause?",
    options: [
      "A zero-day exploit targeting a browser vulnerability",
      "A denial-of-service (DDoS) attack originating from the workstation",
      "An attacker is scanning the workstation for open ports.",
      "A malfunction of the network interface card (NIC)"
    ],
    correctAnswer: 0,
    domain: 'Security Operations',
    difficulty: 0.8,
    explanation: "The combination of unusual DNS queries (suggesting attempts to reach attacker-controlled infrastructure) and communication with a known malicious IP (indicating command-and-control or data exfiltration) strongly points to a compromise despite the lack of local malware evidence. This is characteristic of a browser-based attack, such as a zero-day exploit, where the malicious code resides in the browser's memory and may not leave traces on the file system. A DDoS attack would typically involve the workstation being *targeted* by a large volume of traffic, not *originating* it. If an attacker were scanning the workstation, the traffic would likely be *inbound*, not outbound to a known malicious IP. A NIC malfunction would usually result in more general connectivity problems, not targeted communication with a specific malicious destination and unusual DNS queries."
  },
  {
    id: 'threats-023',
    text: "A web application is vulnerable to a cross-site scripting (XSS) attack. An attacker injects malicious JavaScript code into a website comment section. A user viewing the comment section unknowingly executes the attacker's script. What is the PRIMARY impact of this type of attack?",
    options: [
      "The attacker gains direct access to the web server's file system.",
      "The attacker can steal the user's session cookies and impersonate them on the website.",
      "The attacker can launch a denial-of-service (DoS) attack against the web server.",
      "The attacker can modify the website's database directly."
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.8,
    explanation: "XSS primarily targets client-side vulnerabilities, allowing attackers to steal user cookies and hijack sessions. While XSS can sometimes be chained with other attacks, its primary impact is session hijacking. File system access, DoS, and direct database modification are typically associated with other attack vectors."
  },
  {
    id: 'threats-024',
    text: "A security analyst observes a sudden spike in network traffic directed at a web server, originating from numerous distinct IP addresses. The server remains online but experiences significantly degraded performance, making it nearly unusable for legitimate users. Which type of attack is MOST likely occurring?",
    options: [
      "A SQL injection attack",
      "A cross-site scripting (XSS) attack",
      "A distributed denial-of-service (DDoS) attack",
      "A man-in-the-middle (MitM) attack"
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.0,
    explanation: "A DDoS attack overwhelms a target with traffic from multiple sources, causing service disruption. SQL injection targets databases. XSS targets client-side vulnerabilities. MitM attacks intercept communication between two parties. The key here is the *volume* of traffic from *multiple sources* causing *degraded performance*, not complete outage, which is a hallmark of DDoS."
  },
  {
    id: 'threats-025',
    text: "An attacker intercepts communication between a user and a web server, capturing session cookies and other sensitive data. The attacker then uses this information to impersonate the user. Which type of attack has taken place?",
    options: [
      "A phishing attack",
      "A replay attack",
      "A session hijacking attack",
      "A denial-of-service (DoS) attack"
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.5,
    explanation: "Session hijacking involves taking over an existing user session by stealing session identifiers (like cookies). Phishing tricks users into revealing credentials. Replay attacks retransmit captured network traffic. DoS attacks disrupt service availability."
  },
  {
    id: 'threats-026',
    text: "An attacker crafts a malicious email that appears to be from a trusted source, urging the recipient to click a link that leads to a fake login page designed to steal credentials. What type of attack is this?",
    options: [
      "Impersionation",
      "Watering hole",
      "Whaling",
      "Phishing"
    ],
    correctAnswer: 3,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.1,
    explanation: "This is a classic example of phishing. While it could be *spear phishing* if it were highly targeted, the question doesn't specify targeting a specific individual or group. *Whaling* targets high-profile individuals. *Pharming* redirects users to fake websites through DNS manipulation."
  },
  {
    id: 'threats-027',
    text: "An attacker exploits a vulnerability in a web application that allows them to execute arbitrary commands on the server. This is an example of what type of attack?",
    options: [
      "Cross-site scripting (XSS)",
      "SQL injection",
      "Remote Code Execution (RCE)",
      "Denial-of-service (DoS)"
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.9,
    explanation: "RCE allows attackers to run commands on a remote system. XSS targets client-side vulnerabilities. SQL injection targets databases. DoS attacks disrupt service availability."
  },
  {
    id: 'threats-028',
    text: "An attacker modifies DNS records to redirect users from a legitimate website to a fraudulent one. What type of attack is being performed?",
    options: [
      "Phishing",
      "Pharming",
      "Domain hijacking",
      "URL redirection"
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.8,
    explanation: "Modifying DNS records to redirect traffic is known as DNS poisoning or pharming. Phishing uses deceptive emails or websites. Domain hijacking involves taking control of a domain name registration. URL redirection is a legitimate web function that can be misused but is not the primary mechanism of this attack."
  },
  {
    id: 'threats-029',
    text: 'The IT department at a major university receives reports of cryptocurrency mining software appearing on research computers. Upon investigation, they discover modified system files that don\'t appear in normal directory listings. Which category of threat requires immediate investigation?',
    options: [
      'Browser hijacker',
      'Advanced persistent threat',
      'Rootkit',
      'Trojan'
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'The ability to hide system files from normal directory listings strongly indicates a rootkit infection, which operates at the kernel level to conceal malicious activities and maintain persistence on the system.'
  },
  {
    id: 'threats-030',
    text: 'A financial analyst discovers confidential trading algorithms embedded within normal-looking PowerPoint presentations sent to a competitor. During the investigation, which data exfiltration technique requires specific detection tools?',
    options: [
      'SQL injection',
      'Cross-site scripting',
      'Steganography',
      'Buffer overflow'
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.2,
    explanation: 'This describes steganography - hiding data within other file types. Standard security tools often miss this technique because the files appear normal, requiring specialized detection tools to identify hidden content.'
  },
  {
    id: 'threats-031',
    text: 'Log Analysis:\n2024-03-15 09:45 - Process: svchost.exe\nLocation: C:\\Windows\\System32\\hidden\\\nBehavior: Modifying system calls\nWhat type of threat does this indicate?',
    options: [
      'Spyware infection',
      'Trojan horse',
      'Rootkit presence',
      'Ransomware attack'
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.7,
    explanation: 'The combination of a hidden directory and system call modifications are classic indicators of rootkit behavior, which aims to conceal malicious activity by altering core system functionality.'
  },
  {
    id: 'threats-032',
    text: 'Your incident response team discovered this code in a compromised web form:\n```sql\n"; DROP TABLE users; --```\nIdentify the attack technique:',
    options: [
      'Cross-site scripting',
      'SQL injection attempt',
      'Buffer overflow',
      'Command-line injection'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.8,
    explanation: 'The syntax showing an SQL command with table manipulation attempts clearly indicates SQL injection, where attackers try to modify database queries through malicious input.'
  },
  {
    id: 'threats-033',
    text: 'A developer discovers the test environment\'s hypervisor allows processes in one container to access memory locations of another container. This indicates what type of virtualization vulnerability?',
    options: [
      'Container sprawl',
      'Resource exhaustion',
      'VM escape',
      'Privilege escalation'
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.5,
    explanation: 'VM escape occurs when the isolation between virtual environments is compromised, allowing one virtual instance to access resources or memory spaces of another, breaking the fundamental security boundary virtualization should provide.'
  },
  {
    id: 'threats-034',
    text: 'A phishing analysis reveals messages impersonating your company CEO requesting urgent cryptocurrency payments. Which social engineering vector requires immediate user awareness training?',
    options: [
      'Vishing attack',
      'SMS phishing',
      'Watering hole',
      'Business email compromise'
    ],
    correctAnswer: 3,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'This describes a business email compromise (BEC) attack where attackers impersonate executives to request fraudulent payments. Training users to verify unusual payment requests through separate communication channels is essential.'
  },
  {
    id: 'threats-034b',
    text: 'During a cloud migration assessment, you discover development teams deploying unauthorized cloud resources without IT approval. Which scenario needs addressing?',
    options: [
      'Data theft',
      'Shadow IT',
      'Privilege abuse',
      'Internal threat'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'Shadow IT occurs when departments deploy technology resources without IT department oversight, potentially introducing security risks through unmanaged and improperly configured systems.'
  },
  {
    id: 'threats-035',
    text: 'A security researcher is investigating anonymous communication methods used by threat actors. Which characteristic of the Tor network makes it particularly attractive for malicious activities?',
    options: [
      'The ability to route traffic through multiple relays hiding the original source',
      'Built-in encryption that cannot be broken',
      'Direct peer-to-peer connections between users',
      'Guaranteed fastest network speeds for all traffic'
    ],
    correctAnswer: 0,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'The Tor network uses onion routing through multiple relays to obscure the original source of traffic. This makes it attractive for those seeking anonymity, as each relay only knows its immediate predecessor and successor in the chain, making traffic analysis much more difficult.'
  },

  {
    id: 'threats-036',
    text: 'An organization discovered they were targeted by a previously unknown vulnerability in their web application framework. Which best describes why traditional preventive controls may not be effective against this type of attack?',
    options: [
      'The attack requires physical access to systems',
      'The vulnerability has not been publicly disclosed yet',
      'The attack only works against legacy systems',
      'Signature-based detection is highly effective'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.4,
    explanation: 'Zero-day vulnerabilities are previously unknown security flaws that have not been publicly disclosed. Because they are unknown, traditional preventive controls like signature-based detection or known patches cannot directly prevent their exploitation. This is why defense-in-depth and monitoring for unusual behavior are critical.'
  },
  {
    id: 'threats-037',
    text: 'An attacker has established a covert channel to extract sensitive data from a network. Which technique involves encapsulating stolen data within legitimate protocols to avoid detection?',
    options: [
      'Tunneling',
      'Port scanning',
      'DNS enumeration',
      'Encryption'
    ],
    correctAnswer: 0,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.5,
    explanation: 'Protocol tunneling is a data exfiltration technique where stolen data is encapsulated within legitimate protocols (like HTTP or DNS) to disguise the transfer and bypass security controls. This makes the malicious traffic appear as normal business communication.'
  },
  {
    id: 'threats-038',
    text: 'An attacker is attempting to capture network traffic containing authentication credentials. Which type of attack is being performed?',
    options: [
      'Port scanning',
      'Password sniffing',
      'Hash collision',
      'Session hijacking'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.3,
    explanation: 'Password sniffing involves monitoring network traffic to capture authentication packets containing credentials. This attack is particularly effective against protocols that transmit passwords in cleartext or weak encryption.'
  },
  {
    id: 'threats-039',
    text: 'Which password attack methodology involves systematically attempting every possible combination of characters?',
    options: [
      'Timeout attack',
      'Rainbow-table attack',
      'Dictionary attack',
      'Brute force attack'
    ],
    correctAnswer: 3,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'A brute force attack attempts every possible character combination to discover passwords. While comprehensive, this method is time-consuming and often used as a last resort after other methods like dictionary attacks.'
  },
  {
    id: 'threats-040',
    text: 'A CFO receives an email appearing to be from the CEO requesting an urgent wire transfer. The CEO\'s email signature, writing style, and recent meeting details are perfectly replicated.Which attack is this?',
    options: [
      'Whaling',
      'Vishing',
      'Business email compromise',
      'Social engineering'
    ],
    correctAnswer: 0,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.7,
    explanation: 'Whaling specifically targets high-level executives (like CFOs) using sophisticated spear-phishing tactics. While this is also a business email compromise, whaling specifically refers to targeting these "big fish" executives with highly customized attacks.'
  },
  {
    id: 'threats-041',
    text: 'A research director receives a personalized email containing details from their recent conference presentation and a link to "view feedback." Which targeted attack technique is demonstrated?',
    options: [
      'Credential harvesting',
      'Spear phishing',
      'Watering hole',
      'Social media scraping'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.7,
    explanation: 'This demonstrates spear phishing, where attackers use specific, researched details about the target to create highly convincing personalized attacks. The conference details show the attacker\'s research and targeting of this specific individual.'
  },
  {
    id: 'threats-042',
    text: 'A web application automatically submits a form when a user visits a specific page, despite no user interaction. Which vulnerability type enables this behavior?',
    options: [
      'XSS',
      'CSRF',
      'SSRF',
      'Request smuggling'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.7,
    explanation: 'Cross-Site Request Forgery (CSRF) allows attackers to force authenticated users to submit unwanted requests. While XSS involves executing scripts, SSRF involves server requests, and request smuggling involves HTTP parsing, CSRF specifically focuses on unauthorized request submission using the user\'s authenticated session.'
  },
  {
    id: 'threats-043',
    text: 'How does a DDoS attack fundamentally differ from a DoS attack in terms of attack infrastructure?',
    options: [
      'Attack duration',
      'Target selection',
      'Number of source systems',
      'Protocol selection'
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'The key difference between DoS and DDoS is that DDoS attacks utilize multiple compromised systems (a botnet) to generate malicious traffic, while DoS attacks originate from a single source. This makes DDoS attacks harder to mitigate through simple IP blocking.'
  },

  {
    id: 'threats-044',
    text: 'An attacker creates a rogue wireless network with the same SSID as a legitimate network. Which statement accurately describes this attack?',
    options: [
      'It primarily focuses on network impersonation',
      'It mainly relies on signal jamming',
      'It primarily performs eavesdropping',
      'It mainly exploits WPA vulnerabilities'
    ],
    correctAnswer: 0,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.7,
    explanation: 'An evil twin attack is fundamentally a network impersonation attack where the attacker creates a rogue access point mimicking a legitimate network. While eavesdropping may occur as a secondary effect, the primary method is impersonation to intercept traffic.'
  },
  {
    id: 'threats-045',
    text: 'Users are unknowingly directed to a malicious IP address when attempting to visit a legitimate website. Which DNS-related attack is occurring?',
    options: [
      'DNS amplification',
      'DNS cache poisoning',
      'DNS tunneling',
      'DNS zone transfer'
    ],
    correctAnswer: 1,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.7,
    explanation: 'DNS cache poisoning (also known as DNS spoofing) occurs when an attacker corrupts a DNS server\'s cache, causing it to return incorrect IP addresses and redirecting users to malicious sites.This differs from other DNS attacks that focus on different aspects of the DNS infrastructure.'
  },
  {
    id: 'threats-046',
    text: 'An attacker uses extreme physical coercion to obtain an encryption key from a system administrator. This unconventional attack method is known as:',
    options: [
      'Social engineering',
      'Physical exploitation',
      'Rubber hose cryptanalysis',
      'Human vulnerability exploit'
    ],
    correctAnswer: 2,
    domain: 'Threats, Vulnerabilities and Mitigations',
    difficulty: 0.6,
    explanation: 'A "rubber hose attack" refers to extracting cryptographic secrets through coercion or torture. The term highlights that even strong cryptography can be bypassed through human vulnerabilities.'
  },
];